import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux'

import { useFetchPostV2, useSavePost } from '../../components/Hooks/Conexao'
import Mensagens from '../../components/Mensagens';
import { Tabs, Input, Button, Icon, Modal, Drawer, Tag, Select, Divider, InputNumber } from 'antd'
import { LoadingScreen, SubTitulo, IconCheck, IconError, BtnConfirm } from '../../components/Diversos';
import Parametros from './Parametros';
import ZerarEstoque from './ZerarEstoque';
import useForm from '../../components/Hooks/UseForm'
import moment from 'moment'
import Tags from './Tags';
import { setDados } from '../../actions';

const culture = new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
const TabPane = Tabs.TabPane;
const { Option } = Select;
const { TextArea } = Input;

function CliDet({ dados, fetch, onSave, ...props }) {
    const [dadosEditing, setDadosEditing] = useState(false);
    const [showZerarModal, setShowZerarModal] = useState(false);
    const [dadosNome, setDadosNome] = useState(dados.nome);
    const [dadosObs, setDadosObs] = useState(dados.obs);
    const [limiteLojas, setLimiteLojas] = useState(dados.limiteLojas);
    const [showParametros, setShowParametros] = useState(false);
    //const [userEditing, setUserEditing] = useState(null);
    const [userEditing, setUserEditing, handleUserChange] = useForm();
    const [dadosOutros, listarOutros, loadingOutros, setDadosOutros] = useFetchPostV2(fetch, '/cliente', { modelo: 'cli-outros', dados: { id: dados.id } })
    const [dadosNFe, listarNFe, loadingNFe, setDadosNFe] = useFetchPostV2(fetch, '/cliente', { modelo: 'cli-nfe', dados: { id: dados.id } })
    const [dadosNFeDet, setDadosNFeDet] = useState(null);
    const [txtCodigoProdutos, setTxtCodigoProdutos] = useState(null);

    const [saveDados, savingDados] = useSavePost(fetch, '/cliente/save', {
        modelo: 'cliente', dados: {
            id: dados.id,
            nome: dadosNome,
            obs: dadosObs
        }
    },
        () => {
            Mensagens.showSucesso('Gravado com sucesso!');
            onSave();
        });

    const [zerarSenha, zerandoSenha] = useSavePost(fetch, '/cliente/save', { modelo: 'user-zerar-senha', dados: { id: userEditing ? userEditing.id : 0 } },
        () => {
            Mensagens.showSucesso('Senha alterada com sucesso!');
            setUserEditing(null);
        });

    const [saveUser, savingUser] = useSavePost(fetch, '/cliente/save', { modelo: 'user-nome', dados: userEditing },
        () => {
            Mensagens.showSucesso('Usuário alterado com sucesso!');
            setUserEditing(null);
            onSave();
        });

    const [corrigirEstoqueAtual, corrigindoEstoque] = useSavePost(fetch, '/cliente/save', { modelo: 'corrigir-est-atual', dados: { id: dados.id, txt: txtCodigoProdutos } },
        () => {
            Mensagens.showSucesso('Estoque corrigido!');
            onSave();
        });

    const [ativarOuInativar, inativando] = useSavePost(fetch, '/cliente/save', { modelo: 'inativar-conta', dados: { id: dados.id } },
        () => {
            Mensagens.showSucesso('Conta alterada com sucesso!');
            onSave();
        });

    const [excluirProdutosZerados, excluindoProdutosZerados] = useSavePost(fetch, '/cliente/save', { modelo: 'excluir-produtos-zerados', dados: { id: dados.id } },
        () => {
            Mensagens.showSucesso('Produtos excluídos com sucesso!');
            onSave();
        });

    const [saveLimiteLojas, gravandoLimiteLojas] = useSavePost(fetch, '/cliente/save', { modelo: 'cli-limite-lojas', dados: { id: dados.id, limiteLojas: limiteLojas } },
        () => {
            Mensagens.showSucesso('Produtos excluídos com sucesso!');
            onSave();
        });


    function onTabChange(key) {
        if (key == '3' && !dadosOutros && !loadingOutros) {
            listarOutros();
        }
        if (key == '5' && !showParametros) {
            setShowParametros(true);
        }
    }

    function saveCert(data, fileName) {
        const encoder = new TextEncoder();
        const byteArray = encoder.encode(data);
        var blob = new Blob(byteArray, { type: "application/octet-stream" });
        fileName = 'cert.pfx';
        var url = window.URL.createObjectURL(blob);
        let anchorElem = document.getElementById('aDownload');
        anchorElem.href = url;
        anchorElem.download = fileName;

        document.body.appendChild(anchorElem);
        anchorElem.click();

        document.body.removeChild(anchorElem);

        // On Edge, revokeObjectURL should be called only after
        // a.click() has completed, atleast on EdgeHTML 15.15048
        setTimeout(function () {
            window.URL.revokeObjectURL(url);
        }, 1000);
    }

    return (
        <>
            <a id="aDownload" style={{ display: 'none' }} />
            <LoadingScreen loading={savingDados || loadingNFe || corrigindoEstoque || inativando} />
            {/* <pre>{JSON.stringify(dados, null, 2)}</pre> */}
            <Tabs defaultActiveKey="1" onChange={onTabChange}>
                <TabPane tab="Dados" key="1" style={{ minHeight: 300 }}>
                    <div style={{ textAlign: 'center', padding: 5, fontWeight: 'bold', marginBottom: 10, backgroundColor: '#eee' }}>
                        {dados.grupoPK}
                    </div>
                    <div style={{ textAlign: 'right' }}>
                        {dadosEditing && (<Button type="primary" shape="circle" onClick={() => saveDados()} style={{ marginRight: 7 }}><Icon type="save" /></Button>)}
                        <Button type="default" shape="circle" onClick={() => setDadosEditing(true)} disabled={dadosEditing}><Icon type="edit" /></Button>
                    </div>
                    <div>
                        <SubTitulo>Nome</SubTitulo>
                        <Input value={dadosNome} onChange={e => setDadosNome(e.target.value)} disabled={!dadosEditing} />
                        <div style={{ marginTop: 10 }}>
                            <SubTitulo>Observações</SubTitulo>
                            <TextArea rows={5} value={dadosObs} onChange={e => setDadosObs(e.target.value)} disabled={!dadosEditing} />
                        </div>
                    </div>
                </TabPane>
                <TabPane tab="Usuários" key="2">
                    {userEditing && (
                        <div style={{ padding: 15, backgroundColor: '#eee', borderRadius: 5 }}>
                            <div>
                                <Input name="nome" value={userEditing.nome} onChange={handleUserChange} style={{ maxWidth: 300, marginRight: 5 }} />
                                <Input name="email" value={userEditing.email} onChange={handleUserChange} style={{ maxWidth: 300, marginRight: 5 }} />
                                <Button type="primary" onClick={saveUser} loading={savingUser}><Icon type="save" /></Button>
                            </div>
                            <div style={{ marginTop: 8 }}>
                                <Button type="link" style={{ paddingLeft: 0 }} onClick={zerarSenha} loading={zerandoSenha}>Zerar senha</Button>
                            </div>
                        </div>
                    )}
                    <table className="tabela-padrao">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>eMail</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {(dados.usuarios || []).map(v => {
                                return (
                                    <tr key={v.id} style={{ cursor: 'pointer' }}>
                                        <td>{v.nome}</td>
                                        <td>{v.email}</td>
                                        <td className="text-right"><Icon type="edit" onClick={() => setUserEditing({ id: v.id, nome: v.nome, email: v.email })} /></td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </TabPane>
                <TabPane tab="Outros" key="3">
                    <div>
                    {/* {props.userRole == 'Administrator' && */}
                        <div style={{ marginBottom: 15 }}><SubTitulo>Contador: </SubTitulo> <span>{!dados.contadores || dados.contadores.length === 0 ? 'Sem contador vinculado' : dados.contadores.map(e => e.nome).join(', ',)}</span> </div>
                        <div style={{ marginBottom: 15 }}><Button type="link" onClick={() => corrigirEstoqueAtual()} style={{ paddingLeft: 0 }}>Corrigir estoque atual</Button> &nbsp; <Input placeholder='Códigos dos produtos' value={txtCodigoProdutos} size="small" style={{ maxWidth: 400 }} onChange={e => setTxtCodigoProdutos(e.target.value)} /></div>
                        <div style={{ marginBottom: 15 }}><Button type="link" onClick={() => listarNFe()} style={{ paddingLeft: 0 }}>Validar dados para emissão de NFe</Button></div>
                        
                        {props.userRole == 'Administrator' && <div style={{ marginBottom: 15 }}><Button type="link" onClick={() => setShowZerarModal(true)} style={{ paddingLeft: 0 }}>Zerar o estoque</Button></div>}
                        <div>
                            {dados.ativa ? <Tag color="green">Ativa</Tag> : <Tag color="red">Inativa</Tag>}
                            {props.userRole == 'Administrator' && <Button type="link" onClick={() => ativarOuInativar()} >{dados.ativa ? 'Inativar' : 'Ativar'}</Button>}
                        </div>
                        {props.userRole == 'Administrator' && <div style={{ marginBottom: 15 }}><BtnConfirm type="link" onClick={() => excluirProdutosZerados()} style={{ paddingLeft: 0 }} disabled={excluindoProdutosZerados}>Excluir Produtos Zerados</BtnConfirm></div>}
                        <div>
                            {loadingOutros && <div>Carregando...</div>}
                            {dadosOutros && (<div>
                                <div style={{ marginBottom: 15, marginTop: 15 }}>
                                    <InputNumber size='small' value={limiteLojas} onChange={v => setLimiteLojas(v)} />
                                    <Button type="link" onClick={saveLimiteLojas} style={{ paddingLeft: 0 }} loading={gravandoLimiteLojas}>Gravar</Button>
                                </div>
                                <Divider orientation="left" style={{ fontWeight: 'normal', fontSize: 14 }}>Lojas</Divider>
                                {dadosOutros.empresasDados.map(e => {
                                    return (
                                        <div key={e.id}><SubTitulo>{e.nome}</SubTitulo>:  Certificado {e.certValidade ? e.certValidade : '***'} 
                                        {!!e.cert && <a href={process.env.REACT_APP_ADM_API + e.cert} target='_blank' style={{marginLeft: 10}} ><Icon type="download" /></a>}
                                        {/* <Button type="link" onClick={() => saveCert(e.cert, e.nome + '.pfx')}><Icon type="download" /></Button> */}
                                        </div>
                                    )
                                })}

                                <Divider orientation="left" style={{ fontWeight: 'normal', fontSize: 14 }}>Pdvs</Divider>
                                {dadosOutros.pdvs.map(p => {
                                    return (
                                        <div key={p.id}><SubTitulo>{p.estacao}</SubTitulo>  Versão: {p.versao} &nbsp; <Tag>{p.dataAtualizacao}</Tag></div>
                                    )
                                })}

                            </div>)}
                        </div>
                    </div>
                </TabPane>
                <TabPane tab="Marcações" key="4">
                    {showParametros && <Tags id={dados.id} dados={dados.tags}  />}
                </TabPane>
                <TabPane tab="Parâmetros" key="5">
                    {showParametros && <Parametros id={dados.id} />}
                </TabPane>
            </Tabs>

            <Modal
                title="Validação NFe"
                closable={true}
                visible={!(!dadosNFe)}
                onCancel={() => setDadosNFe(null)}
                footer={[<Button key="back" type="primary" ghost onClick={() => setDadosNFe(null)}>Sair</Button>]}
                width={800}
            >
                {dadosNFe && (<>
                    <div><IconCheck ativo={dadosNFe.empresas.valido} /><span style={{ marginLeft: 7 }}>Lojas</span></div>
                    <div style={{ marginTop: 20 }}><IconCheck ativo={dadosNFe.clientes.valido} /><span style={{ marginLeft: 7 }}>Clientes</span> </div>
                    <div style={{ marginTop: 20 }}>
                        {dadosNFe.produtos.valido && (<><IconCheck ativo={true} /><span style={{ marginLeft: 7 }}>Produtos</span></>)}
                        {!dadosNFe.produtos.valido && (<><IconError ativo={true} /><Button type="link" style={{}} onClick={() => setDadosNFeDet(dadosNFe.produtos.invalidos)}>Produtos</Button></>)}
                    </div>
                </>)}
            </Modal>

            <Drawer
                title="Zerar estoque"
                placement="right"
                onClose={() => setShowZerarModal(false)}
                visible={showZerarModal}
                width={500}
                zIndex={3000}>
                {showZerarModal && <ZerarEstoque id={dados.id} />}
            </Drawer>

            <Drawer
                title="Inválidos"
                placement="right"
                onClose={() => setDadosNFeDet(null)}
                visible={!(!dadosNFeDet)}
                width={700}
                zIndex={3000}
            >
                <div>
                    <table className="tabela-padrao">
                        <thead>
                            <tr>
                                <th>Código</th>
                                <th>Descrição</th>
                                <th className="text-center">Ncm</th>
                                <th className="text-center">Ean</th>
                                <th className="text-center">Descrição</th>
                                <th className="text-center">Unidade</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(dadosNFeDet || []).map((x, inx) => {
                                return (<tr>
                                    <td>{x.codigo}</td>
                                    <td>{x.nome}</td>
                                    <td className="text-center" title={`${x.info.ncm}`}>{x.ncm ? <IconCheck ativo={true} /> : <IconError ativo={true} />}</td>
                                    <td className="text-center" title={x.ean}>{x.ean ? <IconCheck ativo={true} /> : <IconError ativo={true} />}</td>
                                    <td className="text-center">{x.descricao ? <IconCheck ativo={true} /> : <IconError ativo={true} />}</td>
                                    <td className="text-center">{x.un ? <IconCheck ativo={true} /> : <IconError ativo={true} />}</td>
                                </tr>)
                            })}

                        </tbody>
                    </table>
                    {/* <pre>{JSON.stringify(dadosNFeDet, null, 2)}</pre> */}
                </div>
            </Drawer>
        </>
    )
}

const mapStateToProps = (state) => {
    return { userRole: state.auth.role  };
  };

export default connect(mapStateToProps, { })(CliDet);